module.exports = __webpack_public_path__ + "img/m5.519d05bf.png";